/* 2026-10-15 (Claude): Swiper's default preloadImages downloads every image of every slider at init, including the
   hidden lightbox images and the display:none gallery images of the decorative product boxes. Visible slides are
   loaded by the browser's native lazy loading, so preloading is switched off for all sliders of the theme. */
if (window.Swiper && typeof window.Swiper.extendDefaults === 'function') {
  window.Swiper.extendDefaults({ preloadImages: false, updateOnImagesReady: false })
}
